// extracted by mini-css-extract-plugin
export default {"import_weight_form":"ImportWeightForm_import_weight_form__fG6lt","spin":"ImportWeightForm_spin__iZsS-"};